export default __webpack_public_path__ + "static/media/press-page-header.75db21f0.png";